<template>
  <Loader v-if="loader" />
  <div class="card">
    <h3>Dashboard Fatturazione</h3>
    
    <div class="action-buttons mb-3">
      <Button label="Riepilogo Fatturato" icon="pi pi-chart-bar" @click="openRiepilogoDialog" class="p-button-info mr-2" />
      <Button label="Scarica CSV" icon="pi pi-download" @click="downloadCsv" class="p-button-primary" />
    </div>

    <div class="grid">
      <div class="col-12">
        <Accordion :activeIndex="0">
          <AccordionTab header="Statistiche Per Mese">
            <DataTable :value="statisticheMese" responsiveLayout="scroll" :paginator="statisticheMese.length > 10" :rows="10" v-model:expandedRows="expandedRows" @rowExpand="onMeseRowClick">
              <Column expander style="width: 5rem" />
              <Column field="mese_fatturazione_formattato" header="Mese"></Column>
              <Column field="quanti" header="Nr. Fatture"></Column>
              <Column field="totale" header="Totale">
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.totale) }}
                </template>
              </Column>
              <template #expansion="slotProps">
                <div class="filter-buttons mb-3">
                  <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
                  <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
                  <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
                </div>
                <DataTable :value="slotProps.data.datiFatture" class="p-datatable-sm" responsiveLayout="scroll"
                stripedRows :paginator="slotProps.data.datiFatture.length > 10" :rows="10"
                :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
                  <Column field="numero" header="Numero">
                    <template #body="{data}">
                      <!-- <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a> -->
                      <Button class="p-button-text" @click="openAutoFatturaDetail(data)">{{ data.numero }}</Button> 
                    </template>
                  </Column>
                  <Column field="ragsoc" header="Cliente">
                    <template #body="slotProps">
                      <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
                    </template>
                  </Column>
                  <!-- <Column field="mese_fatturazione" header="Mese"></Column> -->
                  <Column field="pay" header="Pagamento"></Column>
                  <Column field="consumo" header="Consumo"></Column>
                  <Column field="agente" header="Agente">
                    <template #body="slotProps">
                      <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.agenteId)" class="clickable-link">{{ slotProps.data.agente }}</a>
                    </template>
                  </Column>
                  <Column field="rappresentante" header="Rappresentante">
                    <template #body="slotProps">
                      <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
                    </template>
                  </Column>
                  <Column field="totale" header="Totale">
                    <template #body="slotProps">
                      {{ formatCurrency(slotProps.data.totale) }}
                    </template>
                  </Column>
                </DataTable>
              </template>
              <ColumnGroup type="footer">
                <Row>
                  <Column :colspan="2" class="td-footer"/>
                  <Column :colspan="1" class="td-footer">
                    <template #footer>
                      <div class="flex">Totali</div>
                    </template>
                  </Column>
                  <Column :colspan="1" class="td-footer">
                    <template #footer>
                      <div class="flex">
                        {{calculateTotal(statisticheMese, 'totale')}}
                      </div>
                    </template>
                  </Column>
                </Row>
              </ColumnGroup>
            </DataTable>
          </AccordionTab>
          <AccordionTab header="Statistiche Per Tipo Pagamento">
            <DataTable :value="statistichePagamento" class="p-datatable-sm" responsiveLayout="scroll" stripedRows :paginator="statistichePagamento.length > 10" :rows="10" selectionMode="single" @row-click="onPagamentoRowClick" v-tooltip.top="'Clicca sulla riga per vedere le fatture con questo tipo di pagamento'" :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
              <Column field="name" header="Tipo Pagamento"></Column>
              <Column field="consumo" header="Tipo Consumo"></Column>
              <Column field="quanti" header="Nr. Fatture"></Column>
              <Column field="totale" header="Totale">
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.totale) }}
                </template>
              </Column>
            </DataTable>
          </AccordionTab>
          <AccordionTab header="Statistiche Per Agente">
            <DataTable :value="statisticheAgente" class="p-datatable-sm" responsiveLayout="scroll" stripedRows :paginator="statisticheAgente.length > 10" :rows="10" selectionMode="single" @row-click="onAgenteRowClick" v-tooltip.top="'Clicca sulla riga per vedere i rappresentanti e le fatture dell\'agente'" :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
              <Column field="agente" header="Agente">
                <template #body="slotProps">
                  <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.agenteId || slotProps.data.id)" class="clickable-link">{{ slotProps.data.agente }}</a>
                </template>
              </Column>
              <Column field="quanti" header="Nr. Fatture"></Column>
              <Column field="totale" header="Totale">
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.totale) }}
                </template>
              </Column>
            </DataTable>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
    
    <Dialog v-model:visible="meseDialogVisible" :header="'Fatture del mese di ' + nomeMeseSelezionato" modal :style="{width: '90vw'}" :maximizable="true">
      <div class="filter-buttons mb-3">
        <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
        <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
        <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
      </div>
      <DataTable :value="dialogFattureFiltered" class="p-datatable-sm" responsiveLayout="scroll"
      stripedRows :paginator="dialogFattureFiltered.length > 10" :rows="10"
      :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
      <Column field="numero" header="Numero">
        <template #body="slotProps">
          <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a>
        </template>
      </Column>
      <Column field="ragsoc" header="Cliente">
        <template #body="slotProps">
          <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
        </template>
      </Column>
      <Column field="mese_fatturazione" header="Mese"></Column>
      <Column field="pay" header="Pagamento"></Column>
      <Column field="consumo" header="Consumo"></Column>
      <Column field="agente" header="Agente">
        <template #body="slotProps">
          <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.agenteId)" class="clickable-link">{{ slotProps.data.agente }}</a>
        </template>
      </Column>
      <Column field="rappresentante" header="Rappresentante">
        <template #body="slotProps">
          <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
        </template>
      </Column>
      <Column field="totale" header="Totale">
        <template #body="slotProps">
          {{ formatCurrency(slotProps.data.totale) }}
        </template>
      </Column>
    </DataTable>
  </Dialog>
    
    <Dialog v-model:visible="pagamentoDialogVisible" :header="'Fatture con pagamento ' + nomePagamentoSelezionato" 
           modal :style="{width: '90vw'}" :maximizable="true">

           <div class="filter-buttons mb-3">
        <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
        <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
        <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
      </div>
      <DataTable :value="dialogFattureFiltered" class="p-datatable-sm" responsiveLayout="scroll"
                stripedRows :paginator="dialogFattureFiltered.length > 10" :rows="10"
                :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
        <Column field="numero" header="Numero">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a>
          </template>
        </Column>
        <Column field="ragsoc" header="Cliente">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
          </template>
        </Column>
        <Column field="mese_fatturazione" header="Mese"></Column>
        <Column field="pay" header="Pagamento"></Column>
        <Column field="consumo" header="Consumo"></Column>
        <Column field="agente" header="Agente">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.agenteId)" class="clickable-link">{{ slotProps.data.agente }}</a>
          </template>
        </Column>
        <Column field="rappresentante" header="Rappresentante">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
          </template>
        </Column>
        <Column field="totale" header="Totale">
          <template #body="slotProps">
            {{ formatCurrency(slotProps.data.totale) }}
          </template>
        </Column>
      </DataTable>
    </Dialog>
    
    <Dialog v-model:visible="agenteDialogVisible" :header="'Rappresentanti dell\'agente ' + nomeAgenteSelezionato" 
           modal :style="{width: '90vw'}" :maximizable="true">
      <div>
        <div class="filter-buttons mb-3">
          <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
          <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
          <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
        </div>
        <h5>Rappresentanti</h5>
        <DataTable :value="statisticheRappresentantiFiltered" class="p-datatable-sm mb-4" responsiveLayout="scroll"
                  stripedRows :paginator="statisticheRappresentantiFiltered.length > 10" :rows="10"
                  selectionMode="single" @row-click="onRappresentanteRowClick" v-tooltip.top="'Clicca sulla riga per vedere le fatture del rappresentante'"
                  :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
          <Column field="rappresentante" header="Rappresentante">
            <template #body="slotProps">
              <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
            </template>
          </Column>
          <Column field="quanti" header="Nr. Fatture"></Column>
          <Column field="totale" header="Totale">
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.totale) }}
            </template>
          </Column>
        </DataTable>
        
        <h5>Fatture dell'agente</h5>
        <DataTable :value="datiFattureAgenteFiltered" class="p-datatable-sm" responsiveLayout="scroll"
          stripedRows :paginator="datiFattureAgenteFiltered.length > 10" :rows="10"
          :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
          <Column field="numero" header="Numero">
            <template #body="slotProps">
              <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a>
            </template>
          </Column>
          <Column field="ragsoc" header="Cliente">
            <template #body="slotProps">
              <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
            </template>
          </Column>
          <Column field="mese_fatturazione" header="Mese"></Column>
          <Column field="pay" header="Pagamento"></Column>
          <Column field="consumo" header="Consumo"></Column>
          <Column field="rappresentante" header="Rappresentante">
            <template #body="slotProps">
              <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentanteId)" class="clickable-link">{{ slotProps.data.rappresentante }}</a>
            </template>
          </Column>
          <Column field="totale" header="Totale">
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.totale) }}
            </template>
          </Column>
        </DataTable>
      </div>
    </Dialog>
    
    <Dialog v-model:visible="rappresentanteDialogVisible" :header="'Fatture del rappresentante ' + nomeRappresentanteSelezionato" 
           modal :style="{width: '90vw'}" :maximizable="true">

           <div class="filter-buttons mb-3">
        <Button label="TUTTI" :class="{ 'p-button-outlined': dialogConsumoFilter !== null }" @click="applyDialogConsumoFilter(null)" />
        <Button label="ACCONTO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '1' }" @click="applyDialogConsumoFilter('1')" class="ml-2" />
        <Button label="EFFETTIVO" :class="{ 'p-button-outlined': dialogConsumoFilter !== '2' }" @click="applyDialogConsumoFilter('2')" class="ml-2" />
      </div>

      <DataTable :value="datiFattureRappresentanteFiltered" class="p-datatable-sm" responsiveLayout="scroll"
                stripedRows :paginator="datiFattureRappresentanteFiltered.length > 10" :rows="10"
                :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
        <Column field="numero" header="Numero">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero)" class="clickable-link">{{ slotProps.data.numero }}</a>
          </template>
        </Column>
        <Column field="ragsoc" header="Cliente">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.clienteId)" class="clickable-link">{{ slotProps.data.ragsoc }}</a>
          </template>
        </Column>
        <Column field="mese_fatturazione" header="Mese"></Column>
        <Column field="pay" header="Pagamento"></Column>
        <Column field="consumo" header="Consumo"></Column>
        <Column field="totale" header="Totale">
          <template #body="slotProps">
            {{ formatCurrency(slotProps.data.totale) }}
          </template>
        </Column>
      </DataTable>
    </Dialog>
    
    <Dialog v-model:visible="riepilogoDialogVisible" header="Riepilogo Fatturato" modal :style="{width: '90vw'}" :maximizable="true">
      <div v-if="riepilogoData">
        <!-- <div class="mb-4">
          <h4 class="text-center">Totale Complessivo: {{ formatCurrency(riepilogoData.totale_complessivo) }}</h4>
        </div>
        
        <div class="grid">
          <div class="col-12 md:col-4">
            <div class="p-card p-4 h-full">
              <h5>Riepilogo per Mese</h5>
              <DataTable :value="riepilogoData.statistiche_mesi" class="p-datatable-sm riepilogo-table" responsiveLayout="scroll"
                       stripedRows :paginator="riepilogoData.statistiche_mesi.length > 10" :rows="10"
                       :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
                <Column field="mese_fatturazione" header="Mese" headerStyle="width: 30%; text-align: left" bodyStyle="text-align: left"></Column>
                <Column field="quanti" header="Nr. Fatture" headerStyle="width: 30%; text-align: right" bodyStyle="text-align: right"></Column>
                <Column field="totale" header="Totale" headerStyle="width: 40%; text-align: right" bodyStyle="text-align: right">
                  <template #body="slotProps">
                    {{ formatCurrency(slotProps.data.totale) }}
                  </template>
                </Column>
                <ColumnGroup type="footer">
                  <Row>
                    <Column footer="Totale:" footerStyle="text-align: left; font-weight: bold" />
                    <Column :footer="getTotaleFattureMesi()" footerStyle="text-align: right; font-weight: bold" />
                    <Column :footer="formatCurrency(getTotaleMesi())" footerStyle="text-align: right; font-weight: bold" />
                  </Row>
                </ColumnGroup>
              </DataTable>
            </div>
          </div>
          
          <div class="col-12 md:col-4">
            <div class="p-card p-4 h-full">
              <h5>Riepilogo per Tipo Pagamento</h5>
              <DataTable :value="riepilogoData.statistiche_pagamento" class="p-datatable-sm riepilogo-table" responsiveLayout="scroll"
                       stripedRows :paginator="riepilogoData.statistiche_pagamento.length > 10" :rows="10"
                       :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
                <Column field="name" header="Tipo Pagamento" headerStyle="width: 30%; text-align: left" bodyStyle="text-align: left"></Column>
                <Column field="consumo" header="Tipo Consumo" headerStyle="width: 20%; text-align: left" bodyStyle="text-align: left"></Column>
                <Column field="quanti" header="Nr. Fatture" headerStyle="width: 20%; text-align: right" bodyStyle="text-align: right"></Column>
                <Column field="totale" header="Totale" headerStyle="width: 30%; text-align: right" bodyStyle="text-align: right">
                  <template #body="slotProps">
                    {{ formatCurrency(slotProps.data.totale) }}
                  </template>
                </Column>
                <ColumnGroup type="footer">
                  <Row>
                    <Column footer="Totale:" colspan="2" footerStyle="text-align: left; font-weight: bold" />
                    <Column :footer="getTotaleFatturePagamento()" footerStyle="text-align: right; font-weight: bold" />
                    <Column :footer="formatCurrency(getTotalePagamento())" footerStyle="text-align: right; font-weight: bold" />
                  </Row>
                </ColumnGroup>
              </DataTable>
            </div>
          </div>
          
          <div class="col-12 md:col-4">
            <div class="p-card p-4 h-full">
              <h5>Riepilogo per Agente</h5>
              <DataTable :value="riepilogoData.statistiche_agenti" class="p-datatable-sm riepilogo-table" responsiveLayout="scroll"
                       stripedRows :paginator="riepilogoData.statistiche_agenti.length > 10" :rows="10"
                       :rowClass="(data) => ({ 'colored-row': true, [getRowColor(data)]: true })">
                <Column field="agente" header="Agente" headerStyle="width: 50%; text-align: left" bodyStyle="text-align: left">
                  <template #body="slotProps">
                    <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.id)" class="clickable-link">{{ slotProps.data.agente }}</a>
                  </template>
                </Column>
                <Column field="quanti" header="Nr. Fatture" headerStyle="width: 20%; text-align: right" bodyStyle="text-align: right"></Column>
                <Column field="totale" header="Totale" headerStyle="width: 30%; text-align: right" bodyStyle="text-align: right">
                  <template #body="slotProps">
                    {{ formatCurrency(slotProps.data.totale) }}
                  </template>
                </Column>
                <ColumnGroup type="footer">
                  <Row>
                    <Column footer="Totale:" footerStyle="text-align: left; font-weight: bold" />
                    <Column :footer="getTotaleFattureAgenti()" footerStyle="text-align: right; font-weight: bold" />
                    <Column :footer="formatCurrency(getTotaleAgenti())" footerStyle="text-align: right; font-weight: bold" />
                  </Row>
                </ColumnGroup>
              </DataTable>
            </div>
          </div>
        </div> -->
        <!-- {{ riepilogoData }} -->
        <div v-for="(data, type) of riepilogoData" :key="type">
          <h4>{{ type }}</h4>
          <DataTable :value="data['fatture']" paginator :rows="20" :rowsPerPageOptions="[5, 10, 20, 50]">
            <Column v-for="col of data['colonne']" :key="col.field" :field="col.field" :header="col.header">
              <template #body="slotProps">
                <div v-if="col.type == 'date'">
                  {{ moment(slotProps.data[col.field]).format('DD/MM/Y') }}
                </div>
                <div v-else-if="col.type == 'price'">
                  {{ currencyFormatter.format(slotProps.data[col.field]) }}
                </div>
                <div v-else>{{ slotProps.data[col.field] }}</div>
              </template>
            </Column>
            <ColumnGroup type="footer">
                <Row>
                  <Column :colspan="data['colspan']" class="td-footer"/>
                  <Column :colspan="1" class="td-footer">
                    <template #footer>
                      <div class="flex">{{data['q']}}</div>
                    </template>
                  </Column>
                  <Column :colspan="1" class="td-footer">
                    <template #footer>
                      <div class="flex">
                        {{currencyFormatter.format(data['euro'])}}
                      </div>
                    </template>
                  </Column>
                </Row>
              </ColumnGroup>
          </DataTable>
        </div>
      </div>
    </Dialog>

    <Dialog v-model:visible="visibleDialogAutoFatturaDetail" modal :header="`Dettaglio fattura ${numeroDetailAutoFattura}`" :style="{ width: '90%' }">
      <Accordion :activeIndex="0">
        <AccordionTab v-for="mese in detailAutoFattura" :key="mese.title">
          <DataTable :value="mese" responsiveLayout="scroll">
            <Column field="cod_voce" header="Voce" :sortable="true"></Column>
            <Column field="qta" header="Quantita">
              <template #body="{ data }">
                {{ floatFormatter.format(data.qta !== null ? data.qta : 0) }}
              </template>
            </Column>
            <Column field="unitario" header="Prezzo Unitario (&euro;)">
              <template #body="{ data }">
                {{
                  floatFormatter.format(
                    data.unitario !== null ? data.unitario : 0
                  )
                }}
              </template>
            </Column>
            <Column field="aliquota" header="Aliquota IVA (%)"></Column>
            <Column field="totale" header="Imponibile">
              <template #body="{ data }">
                {{
                  currencyFormatter.format(
                    data.totale !== null ? data.totale : 0
                  )
                }}
              </template>
            </Column>
            <Column field="iva" header="Importo IVA">
              <template #body="{ data }">
                {{ currencyFormatter.format(data.iva !== null ? data.iva : 0) }}
              </template>
            </Column>
            <Column field="totale_ivato" header="Totale">
              <template #body="{ data }">
                {{
                  currencyFormatter.format(
                    data.totale_ivato !== null ? data.totale_ivato : 0
                  )
                }}
              </template>
            </Column>
          </DataTable>
        </AccordionTab>
      </Accordion>
    </Dialog>
  </div>
</template>

<script>
import Service from '@/services/ask-fatturazione/fatturazione-service'
import { ref, getCurrentInstance, onMounted, computed} from 'vue';
import { useToast } from "primevue/usetoast";
import Loader from '@/components/Loader.vue'
import moment from 'moment'

export default {
    components: {
      Loader
    },
     setup() {
      const loader = ref(false)
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const toast = useToast();
      const expandedRows = ref([]);
      const visibleDialogAutoFatturaDetail = ref(false)
      const detailAutoFattura = ref()
      const numeroDetailAutoFattura = ref('')
      
      const toastLifetime = 3000; 
      
      const showToast = (severity, summary, detail) => {
        toast.add({
          severity, 
          summary, 
          detail,
          life: toastLifetime,
          closable: true
        });
      };
      
      const navigateToAgenteDetail = (agenteId) => {
        if (!agenteId) {
          showToast('warn', 'Attenzione', 'ID agente non disponibile');
          return;
        }
        window.open(`/ask/agenti/${agenteId}/dettagli`);
      };
      
      const navigateToRappresentanteDetail = (rappresentanteId) => {
        if (!rappresentanteId) {
          showToast('warn', 'Attenzione', 'ID rappresentante non disponibile');
          return;
        }
        window.open(`/ask/rappresentanti/${rappresentanteId}/dettagli`);
      };
      
      const navigateToFatturaDetail = (numero) => {
        if (!numero) {
          showToast('warn', 'Attenzione', 'Numero fattura non disponibile');
          return;
        }
        window.open(`/ask/clienti/fatture/${numero}/dettagli`);
      };
      
      const navigateToClienteDetail = (clienteId) => {
        if (!clienteId) {
          showToast('warn', 'Attenzione', 'ID cliente non disponibile');
          return;
        }
        window.open(`/ask/clienti/${clienteId}/dettagli`);
      };
      
      const statisticheMese = ref([])
      const statisticheAgente = ref([])
      const statistichePagamento = ref([])
      const statisticheRappresentanti = ref([])
      const datiFatture = ref([])
      const datiFattureAgente = ref([])
      const datiFattureRappresentante = ref([])
      
      const meseDialogVisible = ref(false)
      const pagamentoDialogVisible = ref(false)
      const agenteDialogVisible = ref(false)
      const rappresentanteDialogVisible = ref(false)
      
      const nomeMeseSelezionato = ref('')
      const nomePagamentoSelezionato = ref('')
      const nomeAgenteSelezionato = ref('')
      const nomeRappresentanteSelezionato = ref('')
      
      const selectedConsumo = ref(null)
      const selectedTypePay = ref(null)
      const selectedMese = ref(null)
      const selectedAgente = ref(null)
      const selectedRappresentante = ref(null)
      
      const dialogConsumoFilter = ref(null)
      
      const tipiConsumo = ref([
      { id: '1', name: 'Acconto' },
      { id: '2', name: 'Effettivo' }
      ])
      const tipiPagamento = ref([])
      const mesi = ref([
      { name: 'Gennaio', id: '01' },
      { name: 'Febbraio', id: '02' },
      { name: 'Marzo', id: '03' },
      { name: 'Aprile', id: '04' },
      { name: 'Maggio', id: '05' },
      { name: 'Giugno', id: '06' },
      { name: 'Luglio', id: '07' },
      { name: 'Agosto', id: '08' },
      { name: 'Settembre', id: '09' },
      { name: 'Ottobre', id: '10' },
      { name: 'Novembre', id: '11' },
      { name: 'Dicembre', id: '12' }
      ])
      const agenti = ref([])
      const rappresentanti = ref([])
      
      const getConsumoName = (id) => {
        if (id === '1') return 'Acconto';
        if (id === '2') return 'Effettivo';
        return 'Sconosciuto';
      };
      
      const dialogFattureFiltered = computed(() => {
        if (!dialogConsumoFilter.value) return datiFatture.value;
        return datiFatture.value.filter(item => 
        item.cod_type_consumo === dialogConsumoFilter.value || 
        item.consumo === getConsumoName(dialogConsumoFilter.value)
        );
      });
      
      const datiFattureAgenteFiltered = computed(() => {
        if (!dialogConsumoFilter.value) return datiFattureAgente.value;
        return datiFattureAgente.value.filter(item => 
        item.cod_type_consumo === dialogConsumoFilter.value || 
        item.consumo === getConsumoName(dialogConsumoFilter.value)
        );
      });
      const floatFormatter = new Intl.NumberFormat("it-IT", {
        maximumFractionDigits: 10,
      })

      const currencyFormatter = new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      })

      const floatFixFormatter = new Intl.NumberFormat("it-IT", {
        maximumFractionDigits: 3,
      })
      
      const datiFattureRappresentanteFiltered = computed(() => {
        if (!dialogConsumoFilter.value) return datiFattureRappresentante.value;
        return datiFattureRappresentante.value.filter(item => 
        item.cod_type_consumo === dialogConsumoFilter.value || 
        item.consumo === getConsumoName(dialogConsumoFilter.value)
        );
      });
      
      const statisticheRappresentantiFiltered = computed(() => {
        
        return statisticheRappresentanti.value;
      });
      
      const riepilogoDialogVisible = ref(false);
      const riepilogoData = ref(null);
      
      onMounted(() => {
        loadAllData();
      })
      
      const loadAllData = async () => {
        await Promise.all([
        loadStatistichePerMese(),
        loadStatisticheByPagamento(),
        loadStatisticheByAgente()
        ]);
      }
      
      const applyConsumoFilter = (consumo) => {
        selectedConsumo.value = consumo;
        loadAllData();
      }
      
      const applyDialogConsumoFilter = (consumo) => {
        dialogConsumoFilter.value = consumo;
      }
      
      const loadStatistichePerMese = async () => {
        try {
          loader.value = true;
          await service.getStatistichePerMese(selectedConsumo.value)
          .then(res => {
            res.forEach(element => {
              let split_mese =  element.mese_fatturazione.split('-')
              const meseObj = mesi.value.find(m => m.id == split_mese[1]);
              element.mese_fatturazione_formattato = meseObj ? `${meseObj.name} ${split_mese[0]}` : element.mese_fatturazione;
              
              element.datiFatture = []
            });
            statisticheMese.value = res;
          })
          showToast('success', 'Successo', 'Statistiche per mese caricate');
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento delle statistiche per mese');
        } finally {
          loader.value = false;
        }
      }
      
      const loadStatisticheByPagamento = async () => {
        try {
          loader.value = true;
          const response = await service.getStatisticheByPagamento(selectedConsumo.value);
          statistichePagamento.value = response;
          
          const uniquePaymentTypes = [...new Map(response.map(item => 
          [item.id, { id: item.id, name: item.name }]
          )).values()];
          tipiPagamento.value = uniquePaymentTypes;
          
          showToast('success', 'Successo', 'Statistiche per pagamento caricate');
          return response;
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento delle statistiche per pagamento');
          return [];
        } finally {
          loader.value = false;
        }
      }
      
      const loadStatisticheByAgente = async () => {
        try {
          loader.value = true;
          const response = await service.getStatisticheByAgente(selectedConsumo.value, selectedTypePay.value);
          statisticheAgente.value = response;
          
          agenti.value = response.map(item => ({
            id: item.id,
            name: item.agente
          }));
          
          showToast('success', 'Successo', 'Statistiche per agente caricate');
          return response;
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento delle statistiche per agente');
          return [];
        } finally {
          loader.value = false;
        }
      }
      
      const onMeseRowClick = async (event) => {
        let {data} = event
        if (!data.loadedFatture) {
          try {
            loader.value = true;
            selectedMese.value = data.mese_fatturazione;
            
            dialogConsumoFilter.value = null;
            
            const meseObj = mesi.value.find(m => m.id === data.mese_fatturazione);
            nomeMeseSelezionato.value = meseObj ? meseObj.name : data.mese_fatturazione;
            
            await service.getDataByMese(data.mese_fatturazione, selectedConsumo.value)
            .then(res => {              
              data.datiFatture = res;
              data.loadedFatture = true
            })
            
            showToast('success', 'Successo', 'Dati mese caricati');
          } catch (error) {
            showToast('error', 'Errore', 'Errore nel caricamento dei dati mese');
          } finally {
            loader.value = false;
          }
        }
        
      }
      
      const onPagamentoRowClick = (event) => {
        openPagamentoDialog(event.data.id, event.data.name);
      }
      
      const onAgenteRowClick = (event) => {
        openAgenteDialog(event.data.id, event.data.agente);
      }
      
      const onRappresentanteRowClick = (event) => {
        openRappresentanteDialog(event.data.cod_rapp, event.data.rappresentante);
      }
      
      const openMeseDialog = async (mese) => {
        try {
          loader.value = true;
          selectedMese.value = mese;
          
          dialogConsumoFilter.value = null;
          
          const meseObj = mesi.value.find(m => m.id === mese);
          nomeMeseSelezionato.value = meseObj ? meseObj.name : mese;
          
          const response = await service.getDataByMese(mese, selectedConsumo.value);
          datiFatture.value = response;
          
          // meseDialogVisible.value = true;
          
          showToast('success', 'Successo', 'Dati mese caricati');
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento dei dati mese');
        } finally {
          loader.value = false;
        }
      }
      const calculateTotal = (array, field, field2 = null, format = true) => {
        let total = 0          
        array.forEach(el => {
          total += el[field] + (field2 ? el[field2] : 0);
        })
        return format ? formatCurrency(total) : total;
      };
      
      const openAutoFatturaDetail = async (data) => {
        numeroDetailAutoFattura.value = data.numero
        detailAutoFattura.value = null
        if (!data.loadedDetails) {
          loader.value = true
          await service.getAutoFattureDetail(data.numero)
          .then(res => {
            loader.value = false
            data.detailAutoFattura = res.data
            detailAutoFattura.value = res.data
            visibleDialogAutoFatturaDetail.value = true
          })
        }else{
          detailAutoFattura.value = data.detailAutoFattura
          visibleDialogAutoFatturaDetail.value = true
        }
      }
      
      const openPagamentoDialog = async (payId, payName) => {
        try {
          loader.value = true;
          selectedTypePay.value = payId;
          nomePagamentoSelezionato.value = payName;
          
          dialogConsumoFilter.value = null;
          
          const response = await service.getDataByPay(payId, selectedConsumo.value);
          datiFatture.value = response;
          
          pagamentoDialogVisible.value = true;
          
          showToast('success', 'Successo', 'Dati pagamento caricati');
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento dei dati pagamento');
        } finally {
          loader.value = false;
        }
      }
      
      
      const openAgenteDialog = async (agenteId, agenteName) => {
        try {
          loader.value = true;
          selectedAgente.value = agenteId;
          nomeAgenteSelezionato.value = agenteName;
          
          dialogConsumoFilter.value = null;
          
          const responseRappresentanti = await service.getStatisticheRappresentantiByAgente(
          agenteId, 
          selectedConsumo.value, 
          selectedTypePay.value
          );
          statisticheRappresentanti.value = responseRappresentanti;
          
          const response = await service.getDataByAgente(
          agenteId,
          selectedConsumo.value,
          selectedTypePay.value
          );
          datiFattureAgente.value = response;
          
          agenteDialogVisible.value = true;
          
          showToast('success', 'Successo', 'Dati agente caricati');
        } catch (error) {
          console.error('Errore completo:', error);
          showToast('error', 'Errore', 'Errore nel caricamento dei dati agente');
        } finally {
          loader.value = false;
        }
      }
      
      const openRappresentanteDialog = async (codRapp, rappName) => {
        try {
          loader.value = true;
          selectedRappresentante.value = codRapp;
          nomeRappresentanteSelezionato.value = rappName;
          
          dialogConsumoFilter.value = null;
          
          const response = await service.getDataByRappresentante(
          codRapp,
          selectedAgente.value,
          selectedConsumo.value,
          selectedTypePay.value
          );
          datiFattureRappresentante.value = response;
          
          rappresentanteDialogVisible.value = true;
          
          showToast('success', 'Successo', 'Dati rappresentante caricati');
        } catch (error) {
          showToast('error', 'Errore', 'Errore nel caricamento dei dati rappresentante');
        } finally {
          loader.value = false;
        }
      }
      
      const applyFilters = () => {
        loadAllData();
      }
      
      const formatCurrency = (value) => {
        return parseFloat(value).toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };
      
      const downloadCsv = async () => {
        try {
          loader.value = true;
          showToast('info', 'Download in corso', 'Preparazione del file CSV...');
          
          const blob = await service.downloadCsv(
          'E', 
          selectedConsumo.value, 
          false, 
          false  
          );
          
          const url = window.URL.createObjectURL(blob);
          const fileName = `fatturazione_${new Date().toISOString().split('T')[0]}.csv`;
          
          if ('showSaveFilePicker' in window) {
            try {
              const handle = await window.showSaveFilePicker({
                suggestedName: fileName,
                types: [{
                  description: 'File CSV',
                  accept: { 'text/csv': ['.csv'] },
                }],
              });
              const writable = await handle.createWritable();
              await writable.write(blob);
              await writable.close();
            } catch (err) {
              if (err.name !== 'AbortError') {
                throw err;
              }
            }
          } else {
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
          }
          
          window.URL.revokeObjectURL(url);
          
          showToast('success', 'Download completato', 'Il file CSV è stato scaricato');
        } catch (error) {
          console.error('Errore durante il download del CSV:', error);
          showToast('error', 'Errore', 'Si è verificato un errore durante il download');
        } finally {
          loader.value = false;
        }
      };
      
      const openRiepilogoDialog = async () => {
        try {
          loader.value = true;
          
          const response = await service.getRiepilogoFatturato(selectedConsumo.value);
          
          riepilogoData.value = response;
          
          riepilogoDialogVisible.value = true;
          
          showToast('success', 'Successo', 'Riepilogo fatturato caricato');
        } catch (error) {
          console.error('Errore completo:', error);
          showToast('error', 'Errore', 'Errore nel caricamento del riepilogo fatturato');
        } finally {
          loader.value = false;
        }
      };
      
      const getTotaleMesi = () => {
        if (!riepilogoData.value || !riepilogoData.value.statistiche_mesi) return 0;
        return riepilogoData.value.statistiche_mesi.reduce((sum, item) => sum + parseFloat(item.totale || 0), 0);
      };
      
      const getTotaleFattureMesi = () => {
        if (!riepilogoData.value || !riepilogoData.value.statistiche_mesi) return 0;
        return riepilogoData.value.statistiche_mesi.reduce((sum, item) => sum + parseInt(item.quanti || 0), 0);
      };
      
      const getTotalePagamento = () => {
        if (!riepilogoData.value || !riepilogoData.value.statistiche_pagamento) return 0;
        return riepilogoData.value.statistiche_pagamento.reduce((sum, item) => sum + parseFloat(item.totale || 0), 0);
      };
      
      const getTotaleFatturePagamento = () => {
        if (!riepilogoData.value || !riepilogoData.value.statistiche_pagamento) return 0;
        return riepilogoData.value.statistiche_pagamento.reduce((sum, item) => sum + parseInt(item.quanti || 0), 0);
      };
      
      const getTotaleAgenti = () => {
        if (!riepilogoData.value || !riepilogoData.value.statistiche_agenti) return 0;
        return riepilogoData.value.statistiche_agenti.reduce((sum, item) => sum + parseFloat(item.totale || 0), 0);
      };
      
      const getTotaleFattureAgenti = () => {
        if (!riepilogoData.value || !riepilogoData.value.statistiche_agenti) return 0;
        return riepilogoData.value.statistiche_agenti.reduce((sum, item) => sum + parseInt(item.quanti || 0), 0);
      };
      
      const getRowColor = (item) => {
        if (!item.consumo_annuo || item.consumo_annuo <= 0) return 'white';
        
        if (item.preview_totale_qta_nostorno > item.consumo_annuo) {
          return '#FA585899';
        }
        if (item.preview_totale_qta_nostorno > (item.consumo_annuo / 6)) {
          return 'orange';
        }
        if (item.preview_totale_qta_nostorno > (item.consumo_annuo / 9)) {
          return 'yellow';
        }
        
        return 'white';
      };

    return {
      moment,
      loader, 
      statisticheMese,
      statisticheAgente,
      statistichePagamento,
      statisticheRappresentanti,
      datiFatture,
      datiFattureAgente,
      datiFattureRappresentante,
      meseDialogVisible,
      pagamentoDialogVisible,
      agenteDialogVisible,
      rappresentanteDialogVisible,
      nomeMeseSelezionato,
      nomePagamentoSelezionato,
      nomeAgenteSelezionato,
      nomeRappresentanteSelezionato,
      selectedConsumo,
      selectedTypePay,
      selectedMese,
      selectedAgente,
      selectedRappresentante,
      tipiConsumo,
      tipiPagamento,
      mesi,
      agenti,
      rappresentanti,
      onMeseRowClick,
      onPagamentoRowClick,
      onAgenteRowClick,
      onRappresentanteRowClick,
      openMeseDialog,
      openPagamentoDialog,
      openAgenteDialog,
      openRappresentanteDialog,
      applyFilters,
      formatCurrency,
      applyConsumoFilter,
      applyDialogConsumoFilter,
      dialogConsumoFilter,
      dialogFattureFiltered,
      datiFattureAgenteFiltered,
      datiFattureRappresentanteFiltered,
      statisticheRappresentantiFiltered,
      loadAllData,
      showToast,
      navigateToAgenteDetail,
      navigateToRappresentanteDetail,
      navigateToFatturaDetail,
      navigateToClienteDetail,
      downloadCsv,
      riepilogoDialogVisible,
      riepilogoData,
      openRiepilogoDialog,
      getTotaleMesi,
      getTotaleFattureMesi,
      getTotalePagamento,
      getTotaleFatturePagamento,
      getTotaleAgenti,
      getTotaleFattureAgenti,
      getRowColor,
      expandedRows,
      calculateTotal,
      openAutoFatturaDetail,
      visibleDialogAutoFatturaDetail,
      detailAutoFattura,
      numeroDetailAutoFattura,
      floatFormatter,
      currencyFormatter,
      floatFixFormatter,
    }
  }
}
</script>

<style scoped>
.card {
  background-color: #f4f4f4;
  padding: 16px;
  border-radius: 4px;
}

.p-card {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

:deep(.p-datatable .p-datatable-tbody > tr) {
  cursor: pointer;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background-color: #e9ecef !important;
}

.filter-buttons {
  display: flex;
  justify-content: center;
}

.clickable-link {
  color: #2196F3;
  text-decoration: none;
  font-weight: 500;
}

.clickable-link:hover {
  text-decoration: underline;
  color: #0D47A1;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.h-full {
    height: 100%;
}

:deep(.p-datatable .p-datatable-footer) {
  background-color: #f8f9fa;
  font-weight: 600;
  border-top: 1px solid #dee2e6;
}

:deep(.p-datatable .p-datatable-tfoot > tr > td) {
  text-align: right;
  font-weight: 600;
}

.riepilogo-table {
  width: 100%;
}

:deep(.riepilogo-table .p-column-header-content) {
  justify-content: var(--column-justify, flex-start);
}

:deep(.riepilogo-table .p-datatable-tbody > tr > td) {
  padding: 0.5rem 0.75rem;
}

:deep(.riepilogo-table .p-datatable-wrapper) {
  overflow-x: hidden;
}

:deep(.riepilogo-table .p-datatable-footer) {
  padding: 0.75rem;
  background-color: #f9f9f9;
}

:deep(.colored-row) {
  &.white {
    background-color: white !important;
  }
  
  &.yellow {
    background-color: #FFF9C4 !important;
  }
  
  &.orange {
    background-color: #FFE0B2 !important;
  }
  
  &[class*='#FA585899'] {
    background-color: #FFCDD2 !important;
  }
}

:deep(.p-datatable .p-datatable-tbody > tr.colored-row:hover) {
  background-color: inherit !important;
  opacity: 0.85;
}
</style>
